import React from 'react';

import BlueGradientLayout from '../../../error/layouts/BlueGradientLayout';
import PreloadContainer from '../../components/PreloadContainer';

const PreloadPage: React.FC = () => {
  return (
    <BlueGradientLayout>
      <PreloadContainer />
    </BlueGradientLayout>
  );
};

export default PreloadPage;
